/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Icons = require("./Icons");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ClearButton = function ClearButton(_ref) {
  var onClear = _ref.onClear,
    className = _ref.className,
    closeIcon = _ref.closeIcon,
    size = _ref.size;
  var closeIconProps = {
    className: className,
    size: size,
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      onClear();
    }
  };
  var closeIconEl;
  if (closeIcon && closeIcon !== true) {
    var closeIconParams = {
      onClear: onClear,
      domProps: closeIconProps
    };
    closeIconEl = typeof closeIcon === 'function' ? closeIcon(closeIconParams) : closeIcon;
  }
  if (closeIconEl === undefined) {
    closeIconEl = _react.default.createElement(_Icons.CloseIcon, _objectSpread({}, closeIconProps));
  }
  return closeIconEl;
};
ClearButton.defaultProps = {
  size: 10
};
var _default = ClearButton;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/ClearButton.js
// module id = 646
// module chunks = 0